import React from "react";
import { NavLink } from "react-router-dom";
import { GAMES_CATEGORY_NAV } from "../../../routes/APP_ROUTES";
import "../../../assets/styles/css/game-header.css";

const GamesCategoryHeader = ({ openSearchModal }) => {
  const gamesCtaegoryNav = GAMES_CATEGORY_NAV();
  return (
    <>
      <header className="casino-header  text-white md:py-2 md:px-4">
        <div className="flex items-center">
          {/* Navigation Items */}
          <nav className="flex w-full items-center gap-1 md:px-0 px-10 pt-4 whitespace-nowrap scrollbar-hide overflow-x-auto mr-auto">
            {gamesCtaegoryNav
              .filter((fi) => fi.visible !== false)
              .map((item, index) => (
                <NavLink
                  key={index}
                  to={item.path}
                  className={({ isActive }) =>
                    `flex flex-1 min-w-auto px-4 bg-[#383838] md:min-w-max items-center justify-center gap-2 py-5 rounded-md font-semibold transition-all [&_svg]:max-w-6 [&_svg]:max-h-5 text-white hover:bg-primary hover:text-white  [&_svg_path]:hover:fill-white ${
                      isActive ? "bg-primary !text-white [&_svg_path]:fill-white pointer-events-none" : ""
                    }`
                  }
                >
                  {item.icon}
                  <span className="text-center lg:text-[15px] text-[14px]">{item.label}</span>
                </NavLink>
              ))}
          </nav>
        </div>
      </header>
    </>
  );
};

export default GamesCategoryHeader;
